<template>
	<div class="task-book">
        <div v-if="meetingData.length==0" class="no">当前无关联会议</div>
		<div class="item" v-for="value in meetingData" :key="value.id" @click="goTaskDetail(value.id)">
			<div class="image">
                <img :src="value.banner"/>
            </div>
			<div class="content">
				<div class="title">{{value.name}}</div>
				<p>{{value.start_at.slice(0,16)}}</p>
			</div>
		</div>
	</div>
</template>
<script>
	import {WritersMeetings,PersoanalUserInfo} from '../../../config/interface.js'
	export default{
		data(){
			return{
				userInfo:'',  //用户信息
                meetingData:[]
			}
		},
		created(){
            if(common.is_weixin()){
                //微信端
				this.getUserInfo();
			}else{
                //非微信端
				this.userInfo=this.$store.state.userInfo;
                if(this.userInfo){
					this.getUserInfo();
                }
                else{
                    this.$router.replace({
                        path:'/vascularNews/user/login',
                        query:{url:window.location.href}
                    })	
                }
			}
        },
		mounted(){

		},
		methods:{
			//得到用户信息
            getUserInfo(){
                const url=PersoanalUserInfo;
                let params={};
                const method='POST';
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        let data=res.data;
                        localStorage.setItem('userInfo',JSON.stringify(data));
                        this.$store.dispatch('storageUserInfo',data);	
                        this.userInfo=data;
                        if(this.userInfo&&this.userInfo.mobile_status==1){
							this.getMeetings();
                        }
                        else{
                            common.toast('未绑定手机',1000,'fail',()=>{
                                this.$router.replace({
                                    path:'/vascularNews/user/login',
                                    query:{url:window.location.href}
                            	})
					        })	
                        }
                    }
                })
            },
           //获取专家所有会议
			getMeetings(){
				if(this.userInfo.writer_id){
					const url=WritersMeetings;
					const method='POST';
					let params={
                    	writer_id:this.userInfo.writer_id
               		 };
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							this.meetingData=res.data;
						}
					})

				}
			},
            goTaskDetail(id){
                this.$router.push({
					path:'/vascularNews/personal/taskbookDetail',
                    query:{
                        meeting_id:id
                    }
				})	
            }
		}
	}
</script>
<style lang="scss">
	.task-book{
        .no{
            margin:20px 10px 0 10px;
            text-align: center;
            font-size:16px;
            color: rgb(170, 163, 163);
        }
		.item{
			margin:20px 10px 0 10px;
			background: white;
			display: flex;
			border-radius: 0.2rem;
			img{
				width:100%;
				border-radius: 0.2rem;

			}
			.image{
				width:40%;
				margin:10px;
			}
			.content{
				width:60%;
				height: 70px;
				margin:10px 10px 0 10px;
				position: relative;
				font-size: 16px;
				p{
					position: absolute;
					bottom:0 ;
					font-size: 12px;
					color: rgb(170, 163, 163);
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/TaskBook/Index.vue